//libs
import { connect } from 'react-redux';

// selectors
import { getBreadCrumbs, getProductTitle } from 'shared/store/details/selectors';

// components
import BreadCrumbs from './BreadCrumbs';

const mapStateToProps = (state: any) => {
  return {
    breadCrumbs: getBreadCrumbs(state),
    productTitle: getProductTitle(state),
  };
};

export default connect(mapStateToProps)(BreadCrumbs);
